import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { DEFAULT_PARAGRAPH_ALIGN, DEFAULT_PARAGRAPH_VARIANTS } from './Paragraph.constants';
import { ParagraphRoot } from './Paragraph.styled';
// Component.
// -----------------------------------------------------------------------------
const Paragraph = forwardRef(({ align = DEFAULT_PARAGRAPH_ALIGN, children, variant = DEFAULT_PARAGRAPH_VARIANTS, ...rest }, ref) => (_jsx(ParagraphRoot, { align: align, ref: ref, variant: variant, ...rest, children: children })));
// Component configuration.
// -----------------------------------------------------------------------------
Paragraph.displayName = 'Paragraph';
export default Paragraph;
//# sourceMappingURL=Paragraph.js.map